<template>
    <div class="client">
        <div class="hinter">
            Укажите стоимость, которую Вы готовы оплатить за доставку
        </div>
        <div class="line">
            <div class="field">
                <vue-numeric
                        :minus="false"
                        :precision="2"
                        separator=""
                        thousand-separator=""
                        decimal-separator="."
                        placeholder="Стоимость заказа, руб"
                        v-model="store.order.cost"
                ></vue-numeric>
                <div class="recomend" v-if="parseFloat(store.order.addresses[0].cost) > 0">
                    Рекомендуемая стоимость: {{store.order.addresses[0].cost}} руб.
                </div>
            </div>
            <div class="field">
                <date-picker
                        :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30'}"
                        v-model="store.order.start"
                        lang="ru"
                        type="datetime"
                        format="DD.MM.YYYY HH:mm"
                        :not-before="new Date()"
                        placeholder="Дата заказа"
                />
            </div>
        </div>
        <div class="line">
            <masked-input mask="\+1 (111) 111-11-11" v-model="store.order.client"
                          placeholder="Введите Ваш номер телефона" type="tel"/>
        </div>
        <button type="button" @click="createOrder">Оформить заказ</button>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input';
    import VueNumeric from 'vue-numeric';
    import DatePicker from 'vue2-datepicker';

    export default {
        components: {
            MaskedInput, VueNumeric, DatePicker
        },
        props: ["store", "Api"],
        methods: {
            createOrder() {
                this.store.createOrder().then((response) => {
                    if (response.code == 200) {
                        this.store.openCode();
                    }
                }).catch((error) => {
                    this.store.openMessage(typeof error.response.data.data.message != "undefined" ? error.response.data.data.message : error, 'error');
                });
            }
        }
    }
</script>

<style lang="scss">
    #yacurier-form {
        .client {
            position: relative;

            .hinter {
                font-size: 10px;
                left: 170px;
                padding-left: 90px;
                position: absolute;
                top: -60px;
                width: 300px;
                @media(max-width: 478px) {
                    display: none;
                }

                &:before {
                    background: url('../../../../assets/hint-arrow.png') center center no-repeat;
                    background-size: contain;
                    content: "";
                    display: block;
                    height: 40px;
                    left: 0;
                    width: 80px;
                    position: absolute;
                    top: 7px;
                }
            }

            .line {
                align-items: flex-start;
                display: flex;
                margin: 0 -10px 10px;

                > * {
                    margin-left: 10px;
                    margin-right: 10px;
                }
                .field{
                    flex-grow: 1;
                    flex-shrink: 0;
                    input{
                        border-radius: 0;
                        width: calc(100% - 30px);
                    }
                    .mx-datepicker{
                        input{
                            width: 100%;
                        }
                    }
                    .recomend{
                        font-size: 12px;
                        margin-top: 4px;
                    }
                }


                @media (max-width: 478px) {
                    flex-wrap: wrap;
                    > * {
                        margin-top: 10px;
                        width: calc(100% - 20px);

                        &:first-child {
                            margin-top: 0;
                        }
                    }
                }

                > input {
                    flex-grow: 1;
                    flex-shrink: 0;
                }


            }

            button {
                background: #FFD957;
                border: none;
                border-radius: 5px;
                color: #60605D;
                display: inline-block;
                padding: 10px 20px;
                text-decoration: none;
                transition: all .125s ease-in;

                &:hover {
                    background: #ffd043;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/blocks/FullForm/components/Client.vue